import React from 'react';

import { Stack } from '@mui/material';

import EmailForm from './components/EmailForm';
import PhoneForm from './components/PhoneForm';
import VerificationCodeForm from './components/VerificationCodeForm';
import { SignInWrapperStyled } from './styles';
import { IAuthStep } from './types';
import SecurityHeader from '../../components/SecurityHeader';

const SignIn = React.memo(() => {
  const [step, setStep] = React.useState<IAuthStep>(IAuthStep.phone);
  const [phone, setPhone] = React.useState<string | null>(null);
  const [email, setEmail] = React.useState<string | null>(null);

  const onPhoneSuccess = React.useCallback((value: string) => {
    setStep(IAuthStep.code);
    setPhone(value);
  }, []);

  const onEmailSuccess = React.useCallback((value: string) => {
    setStep(IAuthStep.code);
    setEmail(value);
  }, []);

  const handleEmailForm = React.useCallback(() => {
    setStep(IAuthStep.email);
  }, []);

  const renderForm = React.useMemo(() => {
    if (step === IAuthStep.code) {
      return <VerificationCodeForm phone={phone} email={email} />;
    }

    if (step === IAuthStep.email) {
      return <EmailForm onComplete={onEmailSuccess} />;
    }

    return <PhoneForm onComplete={onPhoneSuccess} onEmail={handleEmailForm} />;
  }, [step, onPhoneSuccess, onEmailSuccess, handleEmailForm, phone, email]);

  return (
    <SignInWrapperStyled width="100%">
      <SecurityHeader />

      <Stack direction="row" height="100%" flex={1} justifyContent="center" alignItems="center">
        {renderForm}
      </Stack>
    </SignInWrapperStyled>
  );
});

export default SignIn;
